<template>
  <portal
    :to="to"
  >
    <slot></slot>
  </portal>
</template>

<script>

export default {
  name: "AppPortal",
  props : ['to'],
};
</script>